<template>
  <el-dialog title="转移汇报" :visible.sync="visible" width="836px" :append-to-body="true" center>
    <div class="title-name">转移汇报</div>
    <el-table
      v-loading="btnTransfer"
      class="el-table"
      :data="reportList"
       :header-cell-style="{ background: '#F5F5F5', color: '#2F3030', fontSize: '14px', fontWeight: '400' }"
      style="width: 100%">
      <el-table-column
        v-if="type==='workPhone'"
        prop="phone"
        label="工作手机号"
        width="180">
      </el-table-column>
      <el-table-column
        v-else-if="type==='workWechat'"
        prop="account"
        label="工作微信号"
        width="180">
      </el-table-column>
      <el-table-column
        v-else-if="type==='workQQ'"
        prop="account"
        label="工作QQ号"
        width="180">
      </el-table-column>
      <el-table-column
        v-else-if="type==='workEmail'"
        prop="account"
        label="工作邮箱"
        width="180">
      </el-table-column>
      <el-table-column
        v-else-if="type==='platformAccount'"
        prop="account"
        label="平台账号"
        width="180">
        <!-- <template slot-scope="scope">
          <span class="account-con" v-for='(name,index) of scope.row.accountList'>
            <span class="account">{{name}}</span>
            <span class="icon">{{scope.row.accountFlagList[index] ? "主" : "子" }}</span>
          </span>
        </template> -->
      </el-table-column>
      <el-table-column
        prop="sourceOwnerUserName"
        label="归属人"
        width="180">
      </el-table-column>
      <el-table-column
        prop="destOwnerUserName"
        label="转移对象">
      </el-table-column>
      <el-table-column
        prop="result"
        label="转移是否已发起">
      </el-table-column>
      <el-table-column
        prop="errorMessage"
        label="失败原因">
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="visible = false">已知悉</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "popTransferReport",
  props: {
    reportList:{
      type:Array,
      default : ()=>[],
    },
    btnTransfer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false,
      type:''
    }
  },
  created() {
    
    
  },
  methods: {
    show(type='workPhone') {
      this.visible = true
      this.type = type
    },
  }
}
</script>

<style lang="scss" scoped>
.title-name{
  position: relative;
  font-weight: bold;
  font-size: 16px;
  color: #2F3030;
  text-align: left;
  font-style: normal;
  padding-left: 6px;
  line-height: 1;
  height: 30px;
  
  &::before{
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 2px;
    height: 16px;
    background: #00B498;
  }
}
.el-table{
  .account-con{
        display: inline-flex;
        align-items: center;
    }
    .icon{
        width: 18px;
        height: 18px;
        display: inline-block;
        border-radius: 2px;
        box-sizing: border-box;
        border: 1px solid #00b498;
        font-size: 11px;
        line-height: 15px;
        color: #00b498;
        text-align: center;
        overflow: hidden;
        margin: 0 5px;
        transform:scale(.9);

    }
}
</style>
